import TransferError from '@app/helper/error';
import TransferErrorMessages from '@app/helper/error/messages';
import { UNLIMITED_TRANSFER_LIMIT } from '@app/constant/sizes';

import TransferConfig, {
  REGEXP_EMAIL,
  REGEXP_BLANK,
  MAX_MESSAGE_SIZE_IN_BYTES,
} from '@module/transfer/config';

export function validate({ transfer, maximumNumberOfRecipients, allowedSize }) {
  // Make sure this Transfer only starts once
  if (hasStarted(transfer.state, transfer.id)) {
    throw new TransferError('AlreadyStarted');
  }
  if (transfer.type !== 'email' && transfer.type !== 'link') {
    throw new TransferError('InvalidTransferType');
  }

  if (!transfer.files.length) {
    throw new TransferError('MissingFiles');
  }

  // For e-mail transfers also make sure we have recipients and sender
  if (transfer.type === 'email') {
    if (!transfer.recipients.length) {
      throw new TransferError('MissingRecipients');
    }
    if (!transfer.sender.replace(REGEXP_BLANK, '')) {
      throw new TransferError('MissingSender');
    }
    if (!transfer.sender.match(REGEXP_EMAIL)) {
      throw new TransferError('InvalidSender');
    }

    // Make sure the recipients are valid too.
    const invalidRecipients = transfer.recipients.filter(
      (email) => !email.match(REGEXP_EMAIL)
    );
    if (invalidRecipients.length) {
      throw new TransferError('InvalidRecipient');
    }

    // We only allow so many recipients for a transfer
    if (transfer.recipients.length > maximumNumberOfRecipients) {
      throw new TransferError(TransferErrorMessages.TOO_MANY_RECIPIENTS);
    }
  }

  // For messages we have a max. size (it's pretty high though)
  const messageSize = unescape(encodeURIComponent(transfer.message)).length;
  if (messageSize > MAX_MESSAGE_SIZE_IN_BYTES) {
    throw new TransferError('MessageTooLarge');
  }

  // If the total transfer size is higher than our limit, notify the user
  if (
    !isTransferSizeUnlimited(allowedSize) &&
    transfer.totalSize > allowedSize
  ) {
    throw new TransferError('TransferTooBig');
  }

  // Does it have more files than we allow?
  if (transfer.files.length > TransferConfig.maximumNumberOfFiles) {
    throw new TransferError('TooManyFiles');
  }
}

export function isTransferSizeUnlimited(allowedSize) {
  return allowedSize === UNLIMITED_TRANSFER_LIMIT;
}

export function hasStarted(transferState, transferid) {
  return transferState !== 'init' || Boolean(transferid);
}
